import useResponsive from '@parsina/framework/clinical/src/hooks/useResponsive';
import SettingsMobile from './Settings.mobile';
import SettingsWeb from './Settings.web';

// Settings is a platform fork (DESIGN-CONCEPT-MOBILE §1.1): two render trees
// over one shared behaviour layer (`useSettingsForm` / `Settings.shared.js`).
const SettingsScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <SettingsMobile /> : <SettingsWeb />;
};

export default SettingsScreen;
